import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './auth';
import { App } from './App.js';

import { clearAllCachedData } from './api/browser-cache.js'

import './custom.scss';

clearAllCachedData('choice-service');

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
    , 
    document.getElementById('root')
);

